import assetPath from '/app/packages/lebenslauf/articles/src/assets/anonyme-bewerbung-ein-schritt-in-richtung-chancengleichheit.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')